import headerScroll from '../partials/header';

export default {
  init() {
    window.onscroll = headerScroll;
  },

  // JavaScript to be fired on all pages, after page specific JS is fired
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/news.js